<template>
  <!--
    RoundnessPicker — ONE "Shape" switch driving corner rounding AND spacing
    density (flat / min / mid / max). The theme store applies them as data-*
    attributes on <html>; style.css maps them to --ui-radius-factor and
    --ui-space-factor.
  -->
  <div class="space-y-2">
    <div class="flex gap-2">
      <button
        v-for="opt in OPTIONS"
        :key="opt.value"
        type="button"
        class="flex-1 flex items-center justify-center gap-2 py-2.5 rounded-xl text-xs font-medium transition-colors"
        :class="
          themeStore.roundness === opt.value
            ? 'bg-primary-500/15 text-primary-500 ring-1 ring-primary-500/40'
            : 'text-gray-500 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-700/50'
        "
        :title="tt(opt.title.en, opt.title.sl)"
        @click="themeStore.setRoundness(opt.value)">
        <span
          class="flex-shrink-0"
          :style="{
            width: '12px',
            height: '12px',
            border: '2px solid currentColor',
            opacity: 0.85,
            borderRadius: opt.preview,
          }"></span>
        {{ tt(opt.label.en, opt.label.sl) }}
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useThemeStore, type Roundness } from '../stores/theme';
import type { Bilingual } from '../config/bilingual';
import { tt } from '../utils/consoleText';

const themeStore = useThemeStore();

const OPTIONS: Array<{ value: Roundness; label: Bilingual; preview: string; title: Bilingual }> = [
  {
    value: 'flat',
    label: { en: 'Flat', sl: 'Ravno' },
    preview: '0px',
    title: { en: 'Flat corners, tighter spacing', sl: 'Ravni vogali, tesnejši razmiki' },
  },
  {
    value: 'min',
    label: { en: 'Min', sl: 'Malo' },
    preview: '2px',
    title: { en: 'Subtle corners, compact spacing', sl: 'Nežno zaobljeni vogali, kompaktni razmiki' },
  },
  {
    value: 'mid',
    label: { en: 'Mid', sl: 'Srednje' },
    preview: '5px',
    title: { en: 'Default corners and spacing', sl: 'Privzeti vogali in razmiki' },
  },
  {
    value: 'max',
    label: { en: 'Max', sl: 'Največ' },
    preview: '9px',
    title: { en: 'Very round corners, roomier spacing', sl: 'Zelo zaobljeni vogali, prostornejši razmiki' },
  },
];
</script>
